define('components/Bootstrap/ax-tooltip',['jquery', 'core/can'], function($, can) {
	
	can.view.attr('ax-tooltip', function(el, attrData) {
		initTooltip.call(this);

		$(el).bind('inserted', initTooltip);
		
		$(el).bind('change', initTooltip);

		$(el).bind('removed', function() {
			$(this).tooltip('destroy');
		});

		$(el).bind("attributes", function(ev){
			if(ev.attributeName === "ax-tooltip") {
				initTooltip.call(this);
			}
		});

		function initTooltip() {

			var $el = $(this),
				text = el.getAttribute('ax-tooltip'),
				options = {
					title: text,
					html: true,
					container: 'body',
					placement: $el.data('placement') || 'top'
				},
				delay = $el.data('delay') || 5000;
			
			if ($el.data('pre') === 'true') {
				options.title = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
			}
			$el.tooltip('destroy');
			if($el.data('show')) {

				options.trigger = 'manual';
				$el
					.tooltip(options)
					.tooltip('show')
					.addClass('first-show')
					.mouseenter(function(){
					    $(this).tooltip('show');
					})
					.mouseleave(function(){
					    $(this).tooltip('hide');
					});

				setTimeout(function(){
					$el
						.tooltip('hide')
						.removeClass('first-show');
				}, delay);

			} else {
				$el.tooltip(options);
			}
		}
	});
	
});
